var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminBranca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.997,
    height: 18.344,
    viewBox: "0 0 22.997 18.344",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_443",
    "data-name": "Grupo 443",
    transform: "translate(-694 -664.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_1",
    "data-name": "Subtra\\xE7\\xE3o 1",
    d: "M12352.5,2420H12340v-3.376c0-1.669,1.767-2.755,3.249-3.371a15.562,15.562,0,0,1,5.418-1.128,14.1,14.1,0,0,1,2.857.341,6.865,6.865,0,0,0-.621,2.032,11.386,11.386,0,0,0-2.237-.236c-3.222,0-6.608,1.638-6.608,2.361v1.238h9.184a6.76,6.76,0,0,0,1.246,2.136Zm-3.821-9a4.5,4.5,0,1,1,4.334-4.5,4.425,4.425,0,0,1-4.312,4.5Zm0-6.864a2.365,2.365,0,1,0,2.274,2.361,2.321,2.321,0,0,0-2.253-2.357Z",
    transform: "translate(-11646 -1738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Outline",
    transform: "translate(704.362 669.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_87",
    "data-name": "Grupo 87",
    transform: "translate(2.271 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2442",
    "data-name": "Caminho 2442",
    d: "M11.409,7.847a3.672,3.672,0,0,0,0-1.044l1.124-.879a.269.269,0,0,0,.064-.341L11.531,3.741a.266.266,0,0,0-.234-.133.249.249,0,0,0-.091.016L9.88,4.157a3.891,3.891,0,0,0-.9-.522l-.2-1.411A.26.26,0,0,0,8.517,2H6.387a.26.26,0,0,0-.261.224l-.2,1.411a4.091,4.091,0,0,0-.9.522L3.7,3.624a.3.3,0,0,0-.1-.016.264.264,0,0,0-.229.133L2.308,5.584a.263.263,0,0,0,.064.341L3.5,6.8a4.223,4.223,0,0,0-.037.522,4.223,4.223,0,0,0,.037.522l-1.124.879a.269.269,0,0,0-.064.341l1.065,1.843a.266.266,0,0,0,.234.133.249.249,0,0,0,.091-.016l1.326-.533a3.891,3.891,0,0,0,.9.522l.2,1.411a.26.26,0,0,0,.261.224h2.13a.26.26,0,0,0,.261-.224l.2-1.411a4.091,4.091,0,0,0,.9-.522l1.326.533a.3.3,0,0,0,.1.016.264.264,0,0,0,.229-.133L12.6,9.067a.269.269,0,0,0-.064-.341Zm-1.054-.911a2.845,2.845,0,0,1,.027.389c0,.112-.011.229-.027.389l-.075.6.474.373.575.447-.373.644-.676-.272-.554-.224-.479.362a3.119,3.119,0,0,1-.666.389l-.564.229-.085.6-.107.719H7.079l-.1-.719-.085-.6-.564-.229a3.022,3.022,0,0,1-.655-.378L5.19,9.282l-.564.229-.676.272-.373-.644.575-.447.474-.373-.075-.6c-.016-.165-.027-.288-.027-.394s.011-.229.027-.389l.075-.6L4.15,5.962l-.575-.447.373-.644.676.272.554.224L5.657,5a3.119,3.119,0,0,1,.666-.389l.564-.229.085-.6.107-.719h.74l.1.719.085.6.564.229a3.022,3.022,0,0,1,.655.378l.485.373.564-.229.676-.272.373.644-.57.453-.474.373Z",
    transform: "translate(-2.271 -2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2443",
    "data-name": "Caminho 2443",
    d: "M9.775,8A1.775,1.775,0,1,0,11.55,9.775,1.775,1.775,0,0,0,9.775,8Zm0,2.663a.888.888,0,1,1,.888-.888A.888.888,0,0,1,9.775,10.663Z",
    transform: "translate(-4.594 -4.45)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminBranca);
export default __webpack_public_path__ + "static/media/admin_branca.460aa26cd1dd6f4d2c91f7b391ccccba.svg";
export { ForwardRef as ReactComponent };